import React from 'react'

const withDimensions = Component => {
  class WithDimensions extends React.Component {
    render() {
      return (
        <Component dimensions={this.context.windowDimensions} {...this.props} />
      )
    }
  }
  WithDimensions.contextTypes = {
    windowDimensions: React.PropTypes.object,
  }
  return WithDimensions
}

export default withDimensions



// WEBPACK FOOTER //
// ./components/layout/withDimensions.js